import React from 'react';
import PropTypes from 'prop-types';

import SwiperUnstyled from '@ecp/common/src/components/unstyled/swiper/SwiperUnstyled';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/grid';
import { ArrowNext, ArrowPrev } from '@ecp/common/src/components/swiper/bo/component/SwiperArrow';
import { StyledRoundedWrapper, SwiperDefaultProps } from '@ecp/common/src/components/swiper/Swiper';
import { SwiperLabel, SwiperOuterLabel } from '@ecp/common/src/components/swiper/bo/component/SwiperController';

const getController = (control) => {
  switch (control) {
    case 'label':
      return SwiperLabel;
    case 'outerLabel':
      return SwiperOuterLabel;
    default:
      return undefined;
  }
};

export const Swiper = React.forwardRef(({ padding, control, ...props }, ref) => {
  const additionalProps = {
    rootProps: { style: { padding } },
    wrapperComponent: StyledRoundedWrapper,
    controllerComponent: getController(control),
  };

  return (
    <SwiperUnstyled
      ref={ref}
      arrowPrevComponent={ArrowPrev}
      arrowNextComponent={ArrowNext}
      wrapperComponent={StyledRoundedWrapper}
      {...additionalProps}
      {...props}
    />
  );
});

Swiper.propTypes = {
  arrowProps: PropTypes.shape({
    type: PropTypes.oneOf(['8', '32']),
    position: PropTypes.oneOf(['outer', 'inner', undefined]),
  }),
  itemList: PropTypes.array,
  itemProps: PropTypes.object,
  pagingProps: PropTypes.object,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  carouselProps: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  control: PropTypes.oneOf(['label', 'outerLabel', undefined]),
  controlProps: PropTypes.object,
  round: PropTypes.bool,
  padding: PropTypes.string,
  backgroundColor: PropTypes.string,
};

Swiper.defaultProps = {
  itemList: [],
  itemProps: {},
  ...SwiperDefaultProps,
};

Swiper.displayName = 'Swiper';
export default Swiper;
